import { resolveInvoiceDocumentPayableAmount } from './invoicePaymentSummary';

const PAID = new Set(['paid', 'completed', 'succeeded', 'success']);
const cents = (value) => Math.round(Number(value) * 100);

// Validation is strictly read-only: do not invent a payable amount or change
// the invoice data. Incomplete data must never render a false $0.00 invoice.
export const validatePublicInvoiceFinancials = (invoice, totals, paymentReadiness = null) => {
  if (!invoice || invoice.id == null) return 'Invoice details could not be loaded.';
  const paid = PAID.has(String(invoice.paymentStatus || '').toLowerCase()) ||
    PAID.has(String(invoice.invoiceStatus || '').toLowerCase());
  const totalCents = Number(totals?.totalCents);
  const amount = Number(invoice.amount);
  const gross = Number(invoice?.paymentSummary?.grossInvoiceTotal);
  const hasFinancialTotal = (Number.isFinite(totalCents) && totalCents > 0) ||
    (Number.isFinite(gross) && gross > 0);
  if (!hasFinancialTotal || (!paid && !(Number.isFinite(amount) && amount > 0))) {
    return 'Invoice totals are not available. Please retry or contact Accounting.';
  }

  if (paymentReadiness?.status === 'ready') {
    const serverCents = cents(paymentReadiness.amountDue);
    const display = resolveInvoiceDocumentPayableAmount(invoice, totalCents / 100);
    const displayCents = cents(display);
    if (!Number.isSafeInteger(serverCents) || serverCents <= 0 ||
        !Number.isSafeInteger(displayCents) || displayCents !== serverCents) {
      return 'The invoice balance could not be matched to the payment amount. Please contact Accounting.';
    }
  }
  return null;
};

export const isVerifiedPaidInvoice = (invoice = {}) =>
  PAID.has(String(invoice.paymentStatus || '').toLowerCase()) ||
  PAID.has(String(invoice.invoiceStatus || '').toLowerCase());
